export default function StressTrack({ label, boxes }: { label: string; boxes: boolean[] }) {
  const entries = boxes.map((filled, i) => ({ filled, id: `${label}-${i}` }));
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-muted-foreground w-16">{label}</span>
      <div className="flex gap-1">
        {entries.map(({ filled, id }) => (
          <input
            key={id}
            type="checkbox"
            checked={filled}
            readOnly
            className="h-4 w-4 rounded border border-border accent-primary"
          />
        ))}
      </div>
    </div>
  );
}
